import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MeshGradientTab } from "@/components/admin/MeshGradientTab";
import { TransparencyLevelsTab } from "@/components/admin/TransparencyLevelsTab";

/**
 * Super Admin → Design Settings — groups visual-design admin tools.
 * Sub-tabs are addressable via ?tab=design&section=mesh|transparency.
 */
export const DesignSettingsTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const section = searchParams.get("section") || "mesh";

  return (
    <Tabs
      value={section}
      onValueChange={(v) =>
        setSearchParams(
          (sp) => {
            sp.set("tab", "design");
            sp.set("section", v);
            return sp;
          },
          { replace: true },
        )
      }
    >
      <TabsList>
        <TabsTrigger value="mesh">External Mesh Gradient</TabsTrigger>
        <TabsTrigger value="transparency">Transparency Levels</TabsTrigger>
      </TabsList>
      <TabsContent value="mesh" className="mt-4">
        <MeshGradientTab />
      </TabsContent>
      <TabsContent value="transparency" className="mt-4">
        <TransparencyLevelsTab />
      </TabsContent>
    </Tabs>
  );
};
